import { render, staticRenderFns } from "./psOutQueryHis.vue?vue&type=template&id=590a07ce&scoped=true"
import script from "./psOutQueryHis.vue?vue&type=script&lang=js"
export * from "./psOutQueryHis.vue?vue&type=script&lang=js"
import style0 from "./psOutQueryHis.vue?vue&type=style&index=0&id=590a07ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "590a07ce",
  null
  
)

export default component.exports